import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
const listeners = new Set();

export const refreshMediaOverrides = async () => {
  try {
    const r = await fetch(`${API}/media/overrides`);
    if (r.ok) {
      cache = await r.json();
      listeners.forEach((fn) => fn(cache));
    }
  } catch { /* keep defaults */ }
  return cache || {};
};

export const useMediaOverrides = () => {
  const [overrides, setOverrides] = useState(cache || {});
  useEffect(() => {
    const fn = (m) => setOverrides(m);
    listeners.add(fn);
    if (!cache) refreshMediaOverrides();
    return () => listeners.delete(fn);
  }, []);
  return overrides;
};

export const slotImg = (overrides, slot, fallback) => overrides[slot] || fallback;
